import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { Button } from './Button';

interface QrCodeViewerProps {
  value: string;
  height: number; // in pixels
}

const QrCodeViewer: React.FC<QrCodeViewerProps> = ({ value, height }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const downloadPng = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const pngUrl = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = pngUrl;
    link.download = 'qrcode.png';
    link.click();
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <QRCodeCanvas
        value={value}
        size={height}
        level="H"
        includeMargin={true}
        ref={canvasRef}
      />
      <div style={{ marginTop: '1rem' }}>
        <Button onClick={downloadPng}>Download</Button>
      </div>
    </div>
  );
};

export default QrCodeViewer;
